import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

var printList = [
  ["personDetails", "Details of Natural person", "प्राकृतिक व्यक्तिको पहिचान विवरण"],
  ["official", "For Official Use Only", "कार्यालय प्रयोजानका लागि मात्र"],
  ["client", "Client's Account No", "ग्राहक नं"],
  ["data", "Date", "मिति"],
  ["referenceNo", "Reference No", "संकेत नम्बर"],
  ["nepalese", "Nepalese", "नेपाली"],
  ["beneficiary", "Beneficiary ID No.", "हिताग्राही खाता नं"],
  ["panClient", "Permanent Account No.", "स्थायी लेखा नं"],
  [
    "pleaseEnterTheEmailAssociatedWithYourAccount",
    "Please enter the email associated with your account",
    "कृपया तपाईको खातासँग सम्बन्धित इमेल प्रविष्ट गर्नुहोस्",
  ],
  ["official", "For Official Use Only", "कार्यालय प्रयोजानका लागि मात्र"],
  ["client", "Client's Account No", "ग्राहक नं"],
  ["data", "Date", "मिति"],
  ["referenceNo", "Reference No", "संकेत नम्बर"],
  ["nepalese", "Nepalese", "नेपाली"],
  ["beneficiary", "Beneficiary ID No.", "हिताग्राही खाता नं"],
  ["panClient", "Permanent Account No.", "स्थायी लेखा नं"],
  [
    "nrnClient",
    "Identification No. and address (In Case of NRN)",
    "गैरआवासिय नेपालीको हकमा परिचयपत्र नं र ठेगाना",
  ],
];

var publicLangList = [
  ...printList,
  ["Personal Information", "Personal Information", "व्यक्तिगत विवरण"],
  ["fName", "First Name", "पहिलो नाम"],
  ["mName", "Middle Name", "बीचको नाम"],
  ["lName", "Last Name", "थर"],
  ["fNameNep", "First Name Nepali", "पहिलो नाम"],
  ["mNameNep", "Middle Name Nepali", "बीचको नाम"],
  ["lNameNep", "Last Name Nepali", "थर"],
  ["selectBankType", "Select Type of Bank Account", "बैंक खाताको प्रकार चयन गर्नुहोस्"],
  ["selectBank", "Select Bank", "बैंक चयन गर्नुहोस्"],
  ["bankAccountNumber", "Account Number", "खाता नम्बर"],
  ["organizationName", "Organization's Name", "संस्थाको नाम"],
  ["address", "Address", "ठेगाना"],
  ["designation", "Designation", "पद"],
  ["employeeId", "ID No of Employee", "कर्मचारीको हकमा कर्मचारी परिचयपत्र नं."],
  ["selectFinancialDetails", "Select Financial Details", "वित्तीय विवरणहरू चयन गर्नुहोस्"],
];

export var langList = [
  ...publicLangList,
  ["Personal Information", "Personal Information", "व्यक्तिगत विवरण"],
  ["name", "Name", "नाम"],
  ["fName", "First Name", "पहिलो नाम"],
  ["mName", "Middle Name", "बीचको नाम"],
  ["lName", "Last Name", "थर"],
  ["selectBankType", "Select Type of Bank Account", "बैंक खाताको प्रकार चयन गर्नुहोस्"],
  ["selectBank", "Select Bank", "बैंक चयन गर्नुहोस्"],
  ["bankAccountNumber", "Account Number", "खाता नम्बर"],
  ["organizationName", "Organization's Name", "संस्थाको नाम"],
  ["address", "Address", "ठेगाना"],
  ["designation", "Designation", "पद"],
  ["employeeId", "ID No of Employee", "कर्मचारी परिचयपत्र नं."],
  ["selectFinancialDetails", "Select Financial Details", "वित्तीय विवरणहरू चयन गर्नुहोस्"],
  ["companyName", "Company Name", "कम्पनीको नाम"],
  ["selectDesignation", "Select Designation", "पद चयन गर्नुहोस्"],
  ["selectRelationship", "Select Relationship", "सम्बन्ध चयन गर्नुहोस्"],


  [
    "politician",
    "Are you a politician or a high-ranking official? ",
    " के तपाई राजनैतिक वा उच्च पदस्थ व्यक्ति हुनुहुन्छ? ",
  ],
  [
    "relatedP",
    "Are you related to a politician or a high-ranking official?",
    " के तपाई राजनैतिक वा उच्च पदस्थ व्यक्ति संग सम्बन्धि हुनुहुन्छ?",
  ],
  [
    "relatedPYes",
    "Name of the concerned political or high ranking official",
    "सम्बन्धित राजनैतिक/ उच्च पदस्थ व्यक्तिको नाम",
  ],

  [
    "hasBeneficiary",
    "Do you have a beneficiary?",
    "के तपाईको हिताधिकारी व्यक्ति छ?"
  ],
  [
    "bName",
    "Beneficiary Name ",
    "हिताधिकारी व्यक्तिको नाम"
  ],

  [
    "offences",
    "Offences ",
    "कसुर*"
  ],
  [
    "felony",
    "Have you been convicted of a felony in the past? ",
    "के तपाई विगतमा कनै सम्बद्ध कसुरमा दोषी प्रमाणित हुन्‌ भएको छ?"
  ],
  [
    "felonyName",
    " Offenses as per clause (s) of section 2 of the Prevention of Money Laundering Act, 2064 ",
    "सम्पत्ति शुद्धिकरण (मनी लाउण्डरिङ्ग। निवारण ऐन, २०६४ को दफा २ को खण्ड (४) बमोजिमका कसुरहरु "
  ],
  ["fromDate", "From Date", "मिति देखि"],
  ["toDate", "To Date", "मिति सम्म"],
  ["nameAndRelation", "Name And Relation", "नाम र सम्बन्ध"],
  ["selectCountry", "Select Country", "देश चयन गर्नुहोस्"],
  ["selectState", "Select State", "प्रदेश चयन गर्नुहोस्"],
  ["selectDistrict", "Select District", "जिल्ला चयन गर्नुहोस्"],
  ["selectMunicipality", "Select Municipality", "गा.पा/न.पा./उ.म.न.पा/म.न.पा. चयन गर्नुहोस्"],
  ["selectWard", "Select Ward", "वडा नं चयन गर्नुहोस्"],
  ["tole", "Tole", "टोल"],
  ["telephoneNo", "Telephone No", "टेलिफोन नं"],
  ["emailId", "Email Id", "इमेल आईडी"],
  ["mobileNo", "Mobile No", "मोबाइल नम्बर"],
  ["blockNo", "Block No", "ब्लक नं"],
  ["fax", "Fax", "फ्याक्स"],
  ["dateInAd", "Date In AD", "ई. सं. मिति"],
  ["dateInBs", "Date In BS", "बि.सं. मिति"],
  ["duplicateBoidData", "Duplicate BOID data ", "Duplicate BOID data"],
  ["kycComparisionInfo", "Kyc Comparision Info", "Kyc तुलना जानकारी"],
  ["issuedDistrict", "Issued District", "जारी जिल्ला"],
  ["citizenshipNo", "Citizenship No.", "नागरिकता नम्बर"],
  ["nrnAddress", "NRN Address", "गैरआवासिय नेपालीको ठेगाना"],
  ["nrnId", "NRN ID", "गैरआवासिय नेपालीको परिचयपत्र नं "],
  ["pan", "PAN", "स्थायी लेखा नं"],
  ["selectNationality", "Select Nationality", "राष्ट्रियता चयन गर्नुहोस्"],
  ["selectDp", "Select KYC AGENT", "केवाइसी  एजेन्ट चयन गर्नुहोस्"],
  ["cName", "Name Of Company", "कम्पनीको नाम"],
  [
    "securitiesTradingRelation",
    "If a customer or any member of their family is currently or has " +
    "been directly involved in the operations, executive leadership, " +
    "or accounting of an organized institution affiliated with the company," +
    "such as a director, executive officer, " +
    "or auditor, please provide details of their involvement:",
    "ग्राहक आफू वा आफ्नो परिवारका कनै सदस्य संगठित संस्थाको संचालक वा कार्यकारी प्रमुख वा लेखापरीक्षक" +
    "बा कम्पनी सचिव वा व्यवस्थापन वा लेखासंग सम्बन्धित कार्यमा विगतमा वा हाल प्रत्यक्ष रुपले  संलग्न " +
    "रहेको भए सोको विवरण:",
  ],
  ["incorporationDate", "Incorporation Date", "कम्पनी स्थापना मिति"],
  ["selectCompanyType", "Select Company Type", "कम्पनीको किसिम चयन गर्नुहोस्"],
  [
    "selectCountryOfRegistration",
    "Select Country of Registration",
    "कम्पनी दर्ता भएको देश चयन गर्नुहोस्",
  ],
  ["registrationOffice", "Registration Office", "दर्ता गर्ने कार्यालय"],
  ["registrationNo", "Registration No", "दर्ता नं."],
  ["registrationDate", "Registration Date(AD)", "दर्ता मिति(ई.सं.)"],
  ["panVatRegistrationNo", "PAN/VAT Registration No", "मूल्य अभिवृद्धि कर नं /स्थायी लेखा नं"],
  ["panEximption", "Pan Eximption Reason", "स्थायी लेखा नं छूट कारण"],
  ["isPanExempted", "Is Pan Exempted?", "स्थायी लेखा नं छूट छ?"],
  ["issuingAuthorityPlace", "Issued District", "जारी जिल्ला"],
  [
    "nameAddressOfCompany",
    "Name and Address of Main Company",
    "सहायक कम्पनी भएमा मुख्य कम्पनीको नाम र ठेगाना",
  ],
  [
    "selectBusinessType",
    "Select Types of Business of the Company",
    "कम्पनीको व्यवसायको किसिम चयन गर्नुहोस्",
  ],
  ["areaOfWork", "Area Of Work", "कार्य क्षेत्र"],
  ["isListed", "Is Listed", "सूचिकरण भए/नभएका"],
  ["listingDate", "Listing Date", "सूचिकरण मिति"],
  ["panNo", "Pan No", "स्थायी लेखा नं"],
  ["orgAddress", "Organization Address", "संस्थाको ठेगाना"],
  ["dpId", "KYC AGENT", "KYC एजेन्ट"],
  ["basicInfo", "Basic Info", "आधारभूत जानकारी"],
  ["citizenship", "Citizenship", "नागरिकता"],
  ["nameEnglish", "Name(English)", "नाम(अंग्रेजी)"],
  ["nameNepali", "Name(Devnagari)", "नाम(देवनागरी)"],
  ["dateOfBirth", "Date of Birth", "जन्ममिति"],
  ["gender", "Gender", "लिंङ्ग"],
  ["male", "Male", "पुरुष"],
  ["female", "Female", "महिला"],
  ["other", "Other", "अन्य"],
  ["nationality", "Nationality", "राष्ट्रियता"],
  ["nrn", "NRN", "गैरआवासिय नेपाली"],
  ["yes", "Yes", "हो"],
  ["no", "No", "होइन"],
  ["minorDetails", "Minor Details", "नाबालिग विवरण"],
  ["notMinor", "Not Minor", "नाबालक होइन"],
  ["iamminor", "You are a Minor", "नाबालिग हुँ"],
  ["iamnotMinor", "You are not a Minor", "नाबालिग होइन"],
  ["boid", "BOID", "हितग्राही खाता"],
  ["haveBoid", "Do you have BOID?", "तपाईं सँग हितग्राही खाता छ?"],
  ["forwardToDp", "Forward To KYC AGENT", "केवाइसी  एजेन्टकोमा फर्वार्ड  गर्नुहोस्"],
  ["createBoid", "Create BOID?", "हितग्राही खाता खोल्नु हुन्छ?"],

  ["createMeroShareId", "Create Mero Share Id?", "Mero Share Id सिर्जना गर्नुहोस्"],
  ["createMeroShare", "Create Meroshare?", "Meroshare सिर्जना गर्नुहोस् "],
  ["typesOfBankAccount", "Account Type", "खाताको प्रकार"],
  ["bank", "Bank", "बैँक"],
  ["bankAccountNumbers", "Account Number", "खाता नम्बर"],
  ["country", "Country", "देश"],
  ["state", "State", "प्रदेश"],
  ["district", "District", "जिल्ला"],
  ["municipality", "Municipality", "गा.पा/न.पा./उ.म.न.पा/म.न.पा."],
  ["ward", "Ward", "वडा नं"],
  ["occupationDetails", "Occupation Details", "पेशागत विवरण"],
  ["moneyLaunderingPrevention", "Money Laundering Declaration", "सम्पत्ति शुद्धिकरण तथा आतङ्गारी क्रियाकलापमा वित्तिय विवरण सम्बन्धी थप विवरण"],

  ["occupationType", "Occupation Type", "पेशाको प्रकार"],
  ["businessType", "Business Type", "व्यापारको प्रकार"],
  ["financialDetails", "Financial Details", "आर्थिक विवरण"],
  [
    "securitiesTrading",
    "Involvement in Investment companies which were established for securities trading",
    "धितोपत्र खरिद बिक्री गर्ने मुख्य उद्देश्यले स्थापित इन्भेष्टमेन्ट कम्पनीमा संग्लन",
  ],
  ["nameSurname", "Name/Surname", "नाम/थर"],
  ["applicantRelationship", "Relationship with Applicant", "निवेदकसँगको सम्बन्ध"],
  ["correspondenceAddress", "Correspondence Address", "पत्राचार ठेगाना"],
  ["ceoName", "Chief Executive Officer's Name", "प्रमुख कार्यकारी अधिकृतको नाम"],
  ["secretaryName", "Company Secretary's Name", "कम्पनी सचिवको नाम"],
  ["typesOfCompany", "Types of Company", "कम्पनीको किसिम"],
  ["countryOfRegistration", "Country Of Registration", "कम्पनी दर्ता भएको देश"],
  ["typesOfBusinessCompany", "Company Business Type", "कम्पनीको व्यवसायको किसिम"],
  ["userPhoto", "User Photo", "प्रयोगकर्ताको फोटो"],
  [
    "declaration",
    " I/We hereby acknowledge that the above disclosed details are true. I/We further hereby consent to bear any legal actions in case any false disclosure of information related to me/us .",
    "मथि उल्लेखित विवरण सत्य तथ्य रहेको र सो विवरणमा कुनै फरक परे कानून बमोजिम सहुँला, बुझाउँला ।",
  ],
  [
    "nameToConfirm",
    "Enter your full name to confirm",
    "पुष्टि गर्न आफ्नो पूरा नाम प्रविष्ट गर्नुहोस्",
  ],
  ["currentAddress", "Current Address", "हालको ठेगाना"],
  ["permanentAddress", "Permanent Address", "स्थायी ठेगाना"],
  ["spouseName", "Spouse Name", "पति/पत्नीको नाम"],
  ["fatherName", "Father's Name", "बुबाको नाम"],
  ["grandFatherName", "Grand Father's Name", "वाजेको नाम"],
  ["signature", "Signature", "हस्ताक्षर"],
  ["photo", "Photo", "फोटो"],
  ["isAuthorizedPerson", "Is Authorized Person?", "अधिकृत व्यक्ति हो?"],
  ["motherName", "Mother Name", "आमाको नाम"],
  ["sonName", "Son Name", "छोराको नाम"],
  ["daughterName", "Daughter Name", "छोरीको नाम (अविवाहित)"],
  ["daughterInLawName", "Daughter in-Law Name", "बुहारीको नाम"],
  ["fatherInLawName", "Father in-Law Name", "ससुराको नाम (विवाहित महिलाको हकमा)"],
  ["motherInLawName", "Mother n-Law Name", "सासुको नाम(विवाहित महिलाको हकमा)"],
  ["nationalId", "National Identification Number", "राष्ट्रिय परिचय पत्र आईडी"],
  ["passport", "Passport", "राहदानी "],
  ["passportNo", "Passport No", "राहदानी नम्बर"],
  ["expiryDate", "Expiry Date", "म्याद सकिने मिति"],
  ["boidDetails", "Boid Details", "हितग्राही खाता विवरण"],
  ["location", "Location", "ठेगाना"],
  ["dpIdDesc", "DP Description", "डि पी विवरण"],
  ["minorDocument", "Minor Document", "नाबालिग कागजात"],
  ["birthCertificate", "Birth Certificate", "जन्मदर्ता प्रमाण पत्र"],
  ["documentId", "Document Id", "कागजात  नम्बर"],
  ["companyTypeOthers", "Others Company Type", "अन्य कम्पनी प्रकार"],
  ["businessTypeOthers", "Others Business Type", "अन्य व्यापारको प्रकार"],
  ["directorTypeOthers", "Others Director Type", "अन्य निर्देशकको प्रकार"],
  ["relationshipOthers", "Others Relationship", "अन्य सम्बन्धको प्रकार"],
  ["occupationTypeOthers", "Others Occupation Type", "अन्य पेशाको प्रकार"],
  ["designationOthers", "Others Designation ", "अन्य पद"],
  ["verificationCode", "Verification Code", "प्रमाणिकरण कोड"],
  ["password", "Password", "पासवर्ड"],
  ["rePassword", "Re-Type Password", "पासवर्ड पुन: टाइप गर्नुहोस् "],
  ["email", "Email", "इमेल"],
  ["companyDetails", "Company Details", "कम्पनी विवरण"],
  ["secName", "Secretary Name", "सचिवको नाम"],
  ["isSubsidiary", "Is Subsidiary", "सहायक कम्पनी भएको"],
  ["gps", "GPS", "जीपीएस"],
  ["image", "Image", "इमेज"],
  ["type", "Type", "प्रकार"],
  ["incorporationDateBs", "Incorporation Date(BS)", "कम्पनी स्थापना मिति(बि.स)"],
  ["registrationDate", "Registration Date", " दर्ता मिति"],
  ["registrationDateBs", "Registration Date(BS)", " दर्ता मिति(बि.स)"],
  ["listingDateBs", "Listing Date(BS)", "सूचीकरण मिति(बि.स)"],
  ["docId", "Doc Id", "कागजात आईडी"],
  ["documentType", "Document Type", "कागजात प्रकार"],
  ["description", "Description", "विवरण"],
  ["issuedFrom", "Issued From", "जारी ठेगाना"],
  ["issuedDate", "Issued Date", "जारी मिति"],
  ["fileName", "File Name", "फाइलको नाम"],
  ["fileId", "File Id", "फाइल आईडी"],
  ["docId", "Document Id", "कागजात आईडी"],
  ["issuedFrom", "Issued From", "जारी ठेगाना"],
  ["issuedDateAd", "Issued Date AD", "जारी मिति ई. सं."],
  ["issuedDateBs", "Issued Date BS", "जारी मिति बि.सं."],
  ["selectDocumentType", "Select Document Type", "कागजात प्रकार चयन गर्नुहोस्"],
  ["uploadFile", "Upload File", "फाइल अपलोड गर्नुहोस् "],
  ["documentUpload", "Document Upload", "कागजात अपलोड गर्नुहोस् "],
  ["bankBranch", "Branch", "साखा"],
  ["selectBankBranch", "Select Bank Branch", "साखा बैँक चयन गर्नुहोस्"],
  ["relation", "Relation", "तपाईसंगको सम्बन्ध*"],
  ["file", "File", "फाइल"],
  ["addressDetails", "Address Details", "ठेगाना विवरण"],
  [
    "isPermanentAddressSame",
    "Is permanent address same as the current address?",
    "के हालको ठेगाना र स्थायी ठेगाना एउटै हो?",
  ],
  ["familyDetails", "Family Details", "परिवार विवरण"],
  ["primary", "Primary", "प्राथमिक"],
  ["action", "Action", "कार्य"],
  ["guardianDetails", "Guardian Details", "संरक्षक विवरण"],
  ["documentDetails", "Document Details", "कागजात विवरण"],
  ["additionalDocuments", "Additional Documents", "अतिरिक्त कागजात"],
  ["boidDetails", "BOID DETAILS", "हितग्राही खाता विवरण"],
  ["declarationHeader", "Declaration", "स्वघोषणा"],
  ["dpName", "DP Name", "डि पी नाम"],
  ["bankDetails", "Bank Details", "बैंक विवरण"],
  ["website", "Website", "वेबसाइट"],
  ["directorDetails", "Director Details", " निर्देशक विवरण"],
  ["isAuthorizedPerson", "Is Authorized Person?", "अधिकृत व्यक्ति हो ?"],
  ["yourKycDetails", "Your KYC Details", " KYC विवरण"],
  ["Complete Address", "Complete Address", "पूरा ठेगाना"],
  ["documentTypeOthers", "Other Document Type", "अन्य कागजात प्रकार"],
  ["tempKycId", "Temporary Kyc Id", "अस्थायी Kyc आईडी"],
  ["permKycId", "Permanent Kyc Id", "स्थायी Kyc आईडी"],
  ["userType", "User Type", "प्रयोगकर्ता प्रकार"],
  ["selectUserType", "Select User Type", "प्रयोगकर्ता प्रकार चयन गर्नुहोस्"],
  ["selectRegistrationOffice", "Select Registration Office", "दर्ता कार्यालय चयन गर्नुहोस्"],
  ["regDistrict", "Registration District", "दर्ता  जिल्ला"],
  ["selectRegDistrict", "Select Registration District", "दर्ता जिल्ला चयन गर्नुहोस्"],
  ["isContactPerson", "Is Contact Person", "सम्पर्क व्यक्ति"],
  ["isDirector", "Is Director", "निर्देशक"],
  ["contactPerson", "Contact Person", "सम्पर्क व्यक्ति"],
  ["selectContactPerson", "Select Contact Person", "सम्पर्क व्यक्ति चयन गर्नुहोस्"],
  ["isDisabled", "Are you differently abled?", "फरक क्षमतता भएको?"],
  ["bs", "(BS)", "(बि.स)"],
  ["ad", "(AD)", "(ई.सं.)"],
  ["xu", "Yes", "छु"],
  ["xa", "Yes", "छ"],
  ["xaina", "No", "छैन"],
  ["hunxa", "Yes", "हुन्छ"],
  ["hudaina", "No", "हुदैन"],
  ["married", "Married", "विवाहित"],
  ["unmarried", "Unmarried", "अविवाहित"],
  ["maritalStatus", "Marital Status", "वैवाहिक स्थिति"],
  ["forward", "Forward", "फर्वार्ड"],
  ["frontSide", "Front Side", "अगाडिको भाग"],
  ["backSide", "Back Side", "पछाडिको भाग"],
  [
    "duplicateErrorMsg",
    "Customer document matched with the following data. Please visit the DP for further processing!!",
    "",
  ],
  ["dynamicDetails", "Other Details", "अन्य विवरण"],
  ["kycId", "KYC ID", ""],
  ["familyInfoMsg", "**If family not present in case of mandatory fields write NA**", ""],
  ["videoKycDetails", "Video Kyc Details", ""],
  ["videoKycSchedule", "Video Kyc Schedule", ""],
  ["sessionDate", "Session Date", ""],
];

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: {
      translations: langList.reduce((a, v) => {
        a[v[0]] = v[1];

        return a;
      }, {}),
    },
    np: {
      translations: langList.reduce((a, v) => {
        a[v[0]] = v[2] || v[1];

        return a;
      }, {}),
    },
  },
  fallbackLng: "en",
  debug: true,

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  // keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false,
  },

  react: {
    wait: true,
  },
});

export default i18n;
